<template>
    <div class = "process_flex">
        <vhead></vhead>
        <!-- banner图 -->
        <div class = "banner_img">
            <div class = "banner_cont">
                <router-link tag="div" to="/list" class = "btn_maiMai"></router-link>
            </div>
        </div>
        <!-- 流程图 -->
        <div class = "process_img">
            <p class = "title">交易流程</p>
            <p class = "title_hr"></p>
            <p class = "img_url"></p>
        </div>
        <!-- 轮播图 -->
        <div class = "swiper_bigcont">
            <p class="resource_title">海量资源任你选</p>
            <div class= "content_more">
                <p class="resource_hr"></p>
                <p class = "getMore" @click="goMoreList()">更多></p>
            </div>
            <el-carousel height="570px" :interval="115000">
                <el-carousel-item v-for="(bItem,bIndex) in bigSwiperVal" :key="bIndex">
                    <div class = "swiper_cont">
                            <div  class = "nav_content clear">
                                <div class = "sale_list clear f1" v-for="(item,index) in bItem.child" :key="index"  @click="goDetail(item.id)"  @mouseover="item.show=2" @mouseout="item.show=1">
                                    <div class = "sale_detailInfo f1">
                                        <p class = "company_name">{{item.name}}</p>
                                        <div class ="company_tag">
                                            <span v-if="item.tagList==null || item.tagList=='' || item.tagList.length==0">暂无标签</span>
                                             <span v-for="(litem,lindex) in item.tagList">{{litem.name}}</span>
                                        </div>
                                         <ul class = "company_detailInfo">
                                            <li><i>行业类别：</i>{{item.industryType}}</li>
                                            <li><i>纳税类别：</i>{{item.taxType}}</li>
                                            <li><i>经营时间：</i>{{item.establishDate | establishDate}}</li>
                                            <li><i>注册资金：</i>{{item.registerCapital}}万</li>
                                        </ul>
                                        <p class = "release_time">发布时间：{{item.createDate/1000 | moment1}}</p>
                                    </div>
                                    <div class = "sale_price f2">
                                        <p v-if="item.priceFace==1">面议</p>
                                        <p v-if="item.priceFace!=1">{{item.price | salePrice}}</p>
                                        <img v-if="item.show==1?true:false" class = "next_detail" src="../../assets/image/arrow.png" alt="">
                                        <img v-if="item.show==2?true:false" class = "next_detail" src="../../assets/image/h_arrow.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <div class = "friendShip">
            <p class = "fri_title">合作伙伴</p>
            <p class = "fri_hr"></p>
            <ul class = "partner_list">
                <li><img src="../../assets/image/3_12.png" alt=""></li>
                <li><img src="../../assets/image/3_03.png" alt=""></li>
                <li><img src="../../assets/image/3_05.png" alt=""></li>
                <li><img src="../../assets/image/3_07.png" alt=""></li>
                <li><img src="../../assets/image/3_09.png" alt=""></li>
                <li><img src="../../assets/image/3_19.png" alt=""></li>
                <li><img src="../../assets/image/3_20.png" alt=""></li>
                <li><img src="../../assets/image/3_22.png" alt=""></li>
                <li><img src="../../assets/image/3_25.png" alt=""></li>
                <li><img src="../../assets/image/3_27.png" alt=""></li>
            </ul>
        </div>
        <!-- 尾部 -->
        <vfoot></vfoot>
        <div style="position:fixed;bottom:0;right:0;width:400px;height:400px;" v-if="swtDataType=='1'">
           <iframe src="static/kefu.html" scrolling="no" frameborder="no" border="0" allow="microphone" style="width:100%;height:100%;" ></iframe>
        </div>
    </div>
</template>
<script>
import vhead from '../common/vhead'
import vfoot from '../common/vfoot'
export default {
    components:{
        vhead,
        vfoot,
    },
    data() {
        return {
            companyForm:{
                page:1,
                rows:17,
                status:2,
            },
            lrPosition:1,
            showId:1,
            bigSwiperVal:[],//轮播公司信息
            swtDataType:'',//商务通状态
        }
    },
    filters:{
        establishDate:function(val){
            let r=Number(val)
            let one=31536000000
            let two=63072000000
            let three=94608000000
            let d=new Date().getTime()
            if(d-r<one){
                return '1年以内'
            }else if(d-r>=one && d-r<two){
                return '1年-2年'
            }else if(d-r>=two && d-r<three){
                return '2年-3年'
            }else if(d-r>=three){
                return '3年以上'
            }
        },
        salePrice:function(val){
            if(val=='面议'){
                return val
            }else{
                return val+'元'
            }
        }
    },
    created() {
    },
    mounted() {
        this.getCompanyList()
        this.getUpperAndLower()
        // this.$router.replace({path:'/login'})
    },
    methods: {
        
        goDetail(ids){
            this.$router.push({path:'/detail',query:{id:ids}})
        },
        goMoreList(){
            this.$router.push({path:'/list'})
        },
        // 获取公司列表数据
        getCompanyList(){
            this.$axios({
                method:'get',
                url:'/jbbcs/tr/company/page',
                params:this.companyForm,
            }).then((res) =>{
                if(res.data.code==1){
                    this.bigSwiperVal=[]
                    let newArr=[]
                    let arr=res.data.rows
                    arr.map((item,index)=>{
                        if(item.industryType==null){
                            item.industryType=''
                        }else{
                            if(item.industryType.indexOf('-')>=0){
                                item.industryType=item.industryType.split('-')[0]
                            }else{
                                item.industryType=item.industryType
                            }
                        }
                        if(item.taxType==null){
                            item.taxType=''
                        }else{
                            var nat = item.taxType.split(',');
                            let v1=''
                            let v2=''
                            if(nat[0]==0){
                                v1='一般纳税人'
                            }else if(nat[0]==1){
                                v1='小规模纳税人'
                            }
                            item.taxType=v1
                        }
                        if(item.hideName==null || item.hideName==''){}else{
                            item.name=item.name.replace(item.hideName,'***')
                        }
                        if(item.priceFace=='1'){
                            item.price='面议'
                        }
                        let img={
                            id: item.id,
                            name: item.name,
                            industryType: item.industryType,
                            registerCapital: item.registerCapital,
                            price: item.price,
                            establishDate: item.establishDate,
                            createDate: item.createDate,
                            taxType: item.taxType,
                            tagList: item.tagList,
                            show:1,
                        }
                        newArr.push(img)
                    })
                    console.log('newARR',newArr)
                    if(newArr.length>0){
                        let swiper1={
                            child:newArr.slice(0,4)
                        }
                        this.bigSwiperVal.push(swiper1)
                    }
                    if(newArr.length>5){
                        let swiper2={
                            child:newArr.slice(4,8)
                        }
                        this.bigSwiperVal.push(swiper2)
                    }
                    if(newArr.length>9){
                        let swiper3={
                            child:newArr.slice(8,12)
                        }
                        this.bigSwiperVal.push(swiper3)
                    }
                    if(newArr.length>13){
                        let swiper4={
                            child:newArr.slice(12,16)
                        }
                        this.bigSwiperVal.push(swiper4)
                    }

                }else if(res.data.code==0){
                    this.$message.error(res.data.msg);
                }
            }).catch((error) =>{    
                this.$message.error('操作失败，请重试');
            })
        },
        // 客服弹窗位置的变化
        getAdd(){
            if(this.lrPosition==1){
                this.lrPosition=2
            }else{
                this.lrPosition=1
            }
        },
        // 去客服
        goService(){
            window.open('https://dct.zoosnet.net/lr/chatpre.aspx?id=dct44015450&lng=cn&r=&rf1=&rf2=&p=https%3A//www.hzjbqy.com/tg/&cid=5d03cb84434f42888ac1e80648748afe&sid=5d03cb84434f42888ac1e80648748afe')
        },
        loadShangwutiong(){
            // document.write()
            
        },
        // 获得商务通的状态
        getUpperAndLower(){
            this.$axios({
                method:'get',
                url:'/jbbcs/owManage/cusWebConfig/getSwtStatus',
            }).then((res) =>{
                if(res.data.code==1){
                    this.swtDataType=res.data.content
                }else if(res.data.code==0){
                    this.$message.error(res.data.msg);
                }
            }).catch((error) =>{    
                this.$message.error('操作失败，请重试');
            })
        },
    },  
}

</script>
<style lang="scss" scoped>
.process_flex{
    width:100%;
    position: relative;
    .banner_img{
        width:100%;
        height: 586px;
        background: url('../../assets/image/banner1.jpg');
    }
    .banner_cont{
        position: relative;
    }
    .btn_maiMai{
        position: absolute;
        top:318px;
        left:368px;
        width:160px;
        height:45px;
        line-height:45px;
        cursor: pointer;
    }
    .process_img{
        width:100%;
        text-align: center;
        margin-top:30px;
        >.title{
            font-size: 30px;
            color:#000;
            margin-bottom:15px;
        }
        >.title_hr{
            width:73px;
            background:#fda45e;
            height:3px;
            margin:0 auto;
        }
        >.img_url{
            width:100%;
            height: 434px;
            margin:30px 0;
            background: url('../../assets/image/pro.jpg');
        }
    }
    .swiper_bigcont{
        width: 100%;
        height: 842px;
        background: url('../../assets/image/banner4.jpg');
        text-align: center;
        .resource_title{
            padding-top:70px;
            font-size: 30px;
            color:#fff;
            margin-bottom:15px;
        }
        .resource_hr{
            width:73px;
            background:#fff;
            height:3px;
            margin:0 auto;
        }
        .content_more{
            width:1040px;
            margin:0 auto;
        }
        .getMore{
            text-align: right;
            color:#fff;
            font-size: 16px;
            margin-top:60px;
            margin-bottom:30px;
            cursor: pointer;
        }
        .getMore:hover{
            color:#fda45e;
        }
        .swiper_cont{
            width:1100px;
            margin:0 auto;
            text-align: center;
            .nav_content{
                width:100%;
            }
            .sale_list{
                width:500px;
                border-radius: 5px;
                -webkit-box-shadow: #ccc 0px 0px 10px; 
                -moz-box-shadow: #ccc 0px 0px 10px; 
                box-shadow: #ccc 0px 0px 10px; 
                padding:19px 0 24px 0;
                margin-bottom:30px;
                background:#fff;
                position: relative;
                cursor: pointer;
                .sale_detailInfo{
                    padding-left:25px;
                    .company_name{
                        font-size:22px;
                        color:#333;
                        text-align: left;
                        margin-bottom:15px;
                    }
                    .company_tag{
                        text-align: left;
                        margin-bottom:22px;
                        >span{
                            display: inline-block;
                            margin-right:15px;
                            background:#fda45e;
                            color:#fff;
                            font-size:14px;
                            border-radius: 3px;
                            padding:3px 5px;
                        }
                    }
                    .company_detailInfo{
                        width:320px;
                        text-align: left;
                        margin-bottom:20px;
                        >li{ 
                            display: inline-block;
                            color:#666;
                            width:155px;
                            text-align: left;
                            >i{
                                color:#999;
                            }
                        }
                    }
                    .release_time{
                        font-size:14px;
                        color:#999;
                        text-align: left;
                    }
                }
                .sale_price{
                    height: 100%;
                    margin-right:30px;
                    color:#fda45e;
                    font-size: 22px;
                    display: block;
                    .next_detail{
                        width:35px;
                        height:23px;
                        position:absolute;
                        right:30px;
                        bottom:24px;
                        cursor: pointer;
                    }
                }
            }
            .sale_list:nth-child(even){
                margin-left: 100px;
            }
        }
    }
    .friendShip{
        width:100%;
        text-align: center;
        height: 567px;
        background:url('../../assets/image/index_1.jpg');
        .fri_title{
            padding-top:110px;
            font-size: 30px;
            color:#000;
            margin-bottom:15px;
        }
        .fri_hr{
            width:73px;
            background:#fda45e;
            height:3px;
            margin:0 auto;
        }
        .partner_list{
            width: 1200px;
            margin:50px auto;
            >li{
                width:214px;
                height:55px;
                margin:20px 18px 20px 0;
                display: inline-block;
                >img{
                    width:100%;
                    height:100%;
                }
            }
        }
    }
}
.f1{
    float: left;
}
.f2{
    float: right;
}
.leftFk{
    left:270px!important;
}
.rightKF{
    left:0;
}
.kfShow{
    position: fixed;
    right:50px;
    bottom:50px;
    width:60px;
    height:60px;
    border-radius: 50%;
    background: #fda45e;
    text-align: center;
    cursor: pointer;
    >span{
        background:url('../../assets/image/mclose.png') no-repeat;
        background-position: 0 0;
        width:32px;
        height:32px;
        display: block;
        margin:0 auto;
        margin-top:15px;
    }
}
// 防止高度塌陷
.clear:after{ clear:both;content:'';display:block;width: 0;height: 0;visibility:hidden;}
</style>
<style>
</style>
<style lang="scss">
.swiper_bigcont{
    .swiper-container{
        width:100%;
    }
    .swiper-wrapper{
        margin-bottom:40px!important;
    }
    .swiper-pagination-bullet {
        width: 19px;
        height: 19px;
        background:#fff;
        opacity: 1;
        margin:0 21px!important;
    }
    .swiper-pagination-bullet-active {
        background:#fda45e!important;
    }
    .swiper-slide{
        width:100%;
    }
    .el-carousel__arrow--left{
        display:none!important;
    }
    .el-carousel__arrow--right{
        display:none!important;
    }
    .el-carousel__indicator{
        padding:12px 10px;
        .el-carousel__button{
            width:19px;
            height:19px;
            border-radius: 50%;
            background:#fff!important;
            opacity: 1;
        }
    }
    .el-carousel__indicators{
        .is-active{
            .el-carousel__button{
                background:#fda45e!important;
            }
        }
    }
}
</style>
<style>
.headerCss{
    background: #fda45e!important;
}
</style>


// WEBPACK FOOTER //
// src/components/companyTransfer/index.vue